import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { constants } from 'app/constants';
import { LoginService } from 'app/services/login.service';
import { SidebarService } from 'app/services/sidebar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  private unsubscribe$ = new Subject();
  headerName: any = '';

  constructor(
    public loginService: LoginService,
    private routes: Router,
    private sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    this.loginService.headerName
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((company_name: string) => {
        this.headerName = company_name;
      });
  }

  onLogout() {
    const status = this.loginService.logoutUserApi('POST');
    status
    .then(() => console.log('Logged Out Successfully'))
    .catch((error: any) => console.log(error))
  }

  onRedirect(redirectPath: string) {
    this.routes.navigate(['/' + redirectPath]);
  }

  showInbox() {
    this.sidebarService.selectUnselectAll(constants.SIDENAVITEMS, false);
    this.routes.navigate(['/app/inbox']);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }
}
